import { render, staticRenderFns } from "./daySta.vue?vue&type=template&id=c1d67276&scoped=true"
import script from "./daySta.vue?vue&type=script&lang=js"
export * from "./daySta.vue?vue&type=script&lang=js"
import style0 from "./daySta.vue?vue&type=style&index=0&id=c1d67276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d67276",
  null
  
)

export default component.exports